import { gql } from 'apollo-angular';

const CHANGE_TIER_REOPTIMIZE = gql`
  mutation changeTierReoptimize($activePurchasePlan: Long!, $offerId: Long!, $tierId: Long!) {
    changeTier(
      tierChangeRequest: {
        activePurchasePlan: $activePurchasePlan
        tierSelectionOptions: { offerId: $offerId, tierId: $tierId }
        changeTierOperation: RE_OPTIMIZE
      }
    ) {
      updated
    }
  }
`;

export default CHANGE_TIER_REOPTIMIZE;
